export function getVersionId(uri: string) {
  return uri.split('/').pop();
}
